import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/nl-BE';

import purchaseBundleApp from './PurchaseBundle';

// Tenant-specific styles
import '../../../scss/site/pages/PurchaseBundle/PurchaseBundle.twh.scss';

purchaseBundleApp(i18n);
